export default ['成功',  '处理中', '失败', '准备'];



// WEBPACK FOOTER //
// ./src/service/constant/ExitRepayStatus.js